import * as React from "react";

import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import SportSelect from "../SportSelect";
import CloseableDialogTitle from "../common/CloseableDialogTitle";

import useDialog from "./useDialog";

export default function CalibrationSetupDialog(): React.JSX.Element {
    const { setDialogType } = useDialog();

    const handleStartCalibration = () => {
        setDialogType("Calibrating");
    };

    return (
        <>
            <CloseableDialogTitle onClose={() => setDialogType("Finished")}>
                Trainer Setup
            </CloseableDialogTitle>
            <DialogContent dividers sx={{ p: 2 }}>
                <Stack spacing={3}>
                    <Typography variant="body1">Welcome!</Typography>
                    <Typography variant="body1">
                        Before you start a workout, we need to confirm your
                        sport and ensure the trainer is ready.
                    </Typography>
                    <SportSelect showOnlyCompatible />
                    <Typography variant="body1">
                        Next we need to check to ensure all moving parts are
                        properly working. You&apos;ll be able to start your
                        workout when this calibration concludes.
                    </Typography>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleStartCalibration}
                    >
                        Start Preparation
                    </Button>
                </Stack>
            </DialogContent>
        </>
    );
}
